<template>
  <div class="pa-2">
    
    <TotalAndAssignedCards />

    <CategorySubcategoryList />

    <!-- Items Data Table -->
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="table"
          height="400"
        ></v-skeleton-loader>
        <ItemsGrid
          v-else
          @chartClick="handleChartClick"
          :filterContext="filterContext"
          @updateFilter="(chartId, ids) => filterContext.updateFilter(chartId, ids)"
        />
      </v-col>
    </v-row>
  </div>
</template>



<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import ItemsGrid from './grids/ItemsGrid.vue';
import CategorySubcategoryList from './lists/CategorySubcategoryList.vue';
import TotalAndAssignedCards from './card-arrays/TotalAndAssignedCards.vue';


const store = useStore();
const dataLoaded = computed(() => store.getters.getDataLoaded);
const filterContext = computed(() => store.state.filterItemsContext);

onMounted(async () => {
  await store.commit('resetFilters');
});

</script>

<style scoped>
.v-chip {
  padding: 0 4px !important;
}
.v-list-item-title {
  width: 100%;
}

@media (max-width: 600px) {
  .v-chip {
    margin: 2px;
  }
  
  .v-list-item {
    padding: 8px;
  }
}
</style>